// src/authToken.js

// Choose the correct cookie Domain automatically.
// - On production (backlinkbanana.com) → ".backlinkbanana.com"
// - On localhost/ips, omit Domain so the browser accepts it.
function cookieDomain() {
  try {
    const h = window.location.hostname;
    if (h.endsWith("backlinkbanana.com")) return ".backlinkbanana.com";
    return "";
  } catch {
    return "";
  }
}

function setCookie(
  name,
  value,
  {
    days = 30,
    path = "/",
    sameSite = "Lax",
    secure = true,
    domain = cookieDomain(),
  } = {}
) {
  const maxAge = days * 24 * 60 * 60;
  let c = `${encodeURIComponent(name)}=${encodeURIComponent(
    value
  )}; Path=${path}; SameSite=${sameSite}; Max-Age=${maxAge}`;
  if (secure) c += `; Secure`;
  if (domain) c += `; Domain=${domain}`;
  document.cookie = c;
}

function deleteCookie(name, { path = "/", domain = cookieDomain() } = {}) {
  let c = `${encodeURIComponent(name)}=; Path=${path}; Max-Age=0`;
  if (domain) c += `; Domain=${domain}`;
  c += `; SameSite=Lax; Secure`;
  document.cookie = c;
}

function readCookie(name) {
  const needle = encodeURIComponent(name) + "=";
  const parts = document.cookie.split(";");
  for (const part of parts) {
    const c = part.trim();
    if (c.startsWith(needle)) {
      return decodeURIComponent(c.slice(needle.length));
    }
  }
  return null;
}

// One-time self-heal: if legacy "auth_token" exists but "token" doesn't, mirror it.
try {
  const legacy = localStorage.getItem("auth_token");
  if (legacy && !localStorage.getItem("token")) {
    localStorage.setItem("token", legacy);
    try { sessionStorage.setItem("token", legacy); } catch {}
  }
} catch {}

// Read token from localStorage / sessionStorage (token or auth_token), else cookie (bbtoken).
export function getAuthToken() {
  try {
    const t = localStorage.getItem("token") || localStorage.getItem("auth_token");
    if (t) return t;
  } catch {}
  try {
    const s = sessionStorage.getItem("token") || sessionStorage.getItem("auth_token");
    if (s) return s;
  } catch {}
  const cookieVal = readCookie("bbtoken");
  return cookieVal || null;
}

// Persist token and mirror to legacy key + first-party cookie
export function setAuthToken(token) {
  try {
    localStorage.setItem("token", token);
    localStorage.setItem("auth_token", token); // keep legacy writers happy
    try {
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("auth_token", token);
    } catch {}
  } catch {}
  setCookie("bbtoken", token, { days: 30 });
}

// Clear all places we store the token
export function clearAuthToken() {
  try {
    localStorage.removeItem("token");
    localStorage.removeItem("auth_token");
  } catch {}
  try {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("auth_token");
  } catch {}
  deleteCookie("bbtoken");
}
